import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  altIconChevron: {
    id: 'course-authoring.course-unit.heading.icon.chevron.alt',
    defaultMessage: 'Toggle dropdown menu',
  },
  loading: {
    id: 'course-authoring.course-unit.heading.breadcrumbs.loading',
    defaultMessage: 'Loading...',
    description: 'Message displayed while loading breadcrumbs content',
  },
});

export default messages;
